import {
  LogoFacebookIcon,
  LogoInstagramIcon,
  LogoXIcon,
} from 'fitify-ui/src/Icon/logo'
import type { LinkTypes } from 'fitify-ui-landing/src/@types'

import { commonData } from '@/data/common'

export const STATIC_LINKS = {
  pressKit:
    'https://drive.google.com/drive/folders/1PR6a0RGe6zv2v2lW3W3X1uKOvA4TR35U?usp=sharing',
}
export const footerSocial: LinkTypes.Navigation[] = [
  {
    type: 'link',
    caption: 'Instagram',
    icon: <LogoInstagramIcon />,
    link: commonData.socialLinks.instagram,
    link_type: '_blank',
    isHiddenOnMobile: false,
  },
  {
    type: 'link',
    caption: 'Facebook',
    icon: <LogoFacebookIcon />,
    link: commonData.socialLinks.facebook,
    link_type: '_blank',
    isHiddenOnMobile: false,
  },
  {
    type: 'link',
    caption: 'X',
    icon: <LogoXIcon />,
    link: commonData.socialLinks.x,
    link_type: '_blank',
    isHiddenOnMobile: false,
  },
]

export const footerNavigation: LinkTypes.Navigation[] = [
  {
    type: 'link',
    caption: 'cl_landing_careers',
    link: '/careers',
    isHiddenOnMobile: false,
  },
  {
    type: 'link',
    caption: 'cl_landing_press',
    link: STATIC_LINKS.pressKit,
    isHiddenOnMobile: false,
  },
]

export const footerCopy: LinkTypes.Navigation[] = [
  {
    type: 'link',
    caption: 'cl_landing_terms_of_service',
    link: '/terms',
    isHiddenOnMobile: false,
  },
  {
    type: 'link',
    caption: 'cl_landing_privacy_policy',
    link: '/privacy-policy',
    isHiddenOnMobile: false,
  },
]
